import * as yup from 'yup'
export const schema = yup.object().shape({
    nome: yup.string().required(),
    cpf: yup.string().required(),
    telefone: yup.string().required(),
    email: yup.string().email(),
    funcao: yup.string()
})
